<template>
  <div v-if="affichageReduit === false">
    <ubi-panel class="PostsList">
      <ubi-list-header
          slot="header"
          :limits="limits"
          :total="results.total"
          :page.sync="page"
          :limit.sync="limit"
          :sort.sync="sort"
          :sortProperties="sortProperties"
      ></ubi-list-header>
      <ubi-list-selection
          slot="selection"
          v-model="selected"
          :current-page-ids="currentSelectablePageIds"
          @select="doSelect"
      ></ubi-list-selection>

      <template slot="actions">
        <div v-if="!selected.length">
          <el-button icon="export" size="mini" v-if="!selected.length" @click="$emit('exporter')">{{
              $t("general.selection.exportAll") }}
          </el-button>
          <el-button size="mini" @click="gestionAffichageReduit(true)" v-if="!affichageReduit">
            <em class="el-icon-s-fold"></em>
            {{$t("users.listMode") }}
          </el-button>
          <el-button size="mini" @click="gestionAffichageReduit(false)" v-if="affichageReduit">
            <em class="el-icon-menu"></em>
            {{$t("users.vignetteMode") }}
          </el-button>
        </div>
        <div v-else>
          <span>
            <span class="inline">{{ $t("general.selection.forSelection") }} ({{
                selectAllMode ? results.total : selected.length
              }}) :</span>
          <el-button-group class="inline">
            <el-button class="PostsList-export" size="mini"
                       @click="$emit('exporter', { selection: selected })">{{ $t("general.selection.export") }}</el-button>
              <el-button class="PostsList-export" size="mini"
                         @click="$emit('modal-delete-list', {quantite: selected.length, selection: selected})"> {{
                  $t("posts.list.delete")
                }}</el-button>
            <el-button class="PostsList-export" size="mini" v-if="!annonceFlux && saisit_en_ligne && $route.name !== 'content-library'"
                       @click="$emit('switch-published', selected)">{{
                $t("general.selection.activateDeactivate")
              }}</el-button>
            <el-button class="PostsList-changeContact" size="mini" v-if="saisit_en_ligne && $route.name !== 'content-library'"
                       @click="$emit('change-contacts', { selection: selected})">{{
                $t("general.selection.changeContact")
              }}</el-button>
            <el-button class="PostsList-changeContact" size="mini" v-if="$route.name !== 'content-library' && hasMultiAccounts && isMainAccount"
                       @click="$emit('change-users', { selection: selected })">{{
                $t("posts.list.assignUser")
              }}</el-button>
          </el-button-group>
          </span>
        </div>
      </template>

      <ubi-list-footer
          slot="footer"
          v-if="results.total > 1"
          :limits="limits"
          :total="results.total"
          :page.sync="page"
          :limit.sync="limit"
          :sort.sync="sort"
          :sortProperties="sortProperties"
      ></ubi-list-footer>
      <ubi-card-container :data="results.list" class="PostsList-cards">
        <template
            v-slot="{
                                  row: {
                                    id,
                                    titre,
                                    dateCreation,
                                    dateModification,
                                    etat,
                                    prix,
                                    prixDisplay,
                                    reference,
                                    donnees,
                                    photoPrincipale,
                                    published,
                                    nbContactsMailtracking,
                                    typeObjet,
                                    sourceCode,
                                    annonceParente,
                                    typeOffre,
                                    nbDiffusions,
                                    nbPortailsActifs,
                                    advertiser
                                  }
                                }"
        >
          <ubi-card
              class="PostsList-item PostItem"
              v-model="selected"
              :label="id"
              :published="published"
              :etat="etat"
              :id="id"
              :typeObjet="typeObjet"
              :typeOffre="typeOffre"
              full-width
              :sourceCode="sourceCode"
              :annonceParente="annonceParente"
              :nbDiffusions="nbDiffusions"
              :nbPortailsActifs="nbPortailsActifs"
              :advertiser="advertiser"
              :checkbox-disabled="!canSelectPostForBulkRow(etat, donnees)"
              @update:published="$emit('switch-published',id, $event)"
          >
            <template v-slot:header>
              <el-row>
                <el-col :span="12" v-if="titre.length>47">
                  <h3>{{ titre | reduire }}...</h3>
<!--                  <div v-if="titre.length<=25" style="height: 20px;"></div>-->
                </el-col>
                <el-col :span="12" v-if="titre.length<=47">
                  <h3>{{ titre | capitalize }}</h3>
<!--                  <div v-if="titre.length<=25" style="height: 20px;"></div>-->
                </el-col>
                <el-col :span="12">
                  <div class="text-right PostItem-reference" v-if="etat === 'M'">&nbsp;</div>
                  <div class="text-right PostItem-reference" v-else-if="etat !== 'M' && reference.length < 15">Réf : {{ reference }}</div>
                  <div class="text-right PostItem-reference" v-else>Réf : {{ reference | reduireRef }}...</div>
                </el-col>
              </el-row>

              <div v-if="(!isPromoteur || (isPromoteur && filter.annonceParente)) && $route.name !== 'content-library'">
                <div class="PostItem-location" v-if="donnees.ville">{{ donnees.ville.valeur | capitalize }}</div>
                <div class="PostItem-price" v-if="typeOffre === 'M' && prix != null">{{ prix.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' €' }}</div>
                <div class="PostItem-price" v-else >{{ prixDisplay }}</div>
                <div class="PostItem-date" v-if="etat != 'S'">
                  <p class="date-creation-card">{{ $t("components.card.createdOn") }} <strong>{{ dateCreation.substring(0,16) }}</strong></p>
                  <p class="date-modification-card">{{ $t("components.card.updatedOn") }} <strong>{{ dateModification.substring(0,16) }}</strong></p>
                </div>
                <div v-else-if="etat == 'S' && sitimmoUser.soldProductsOption === true" class="PostItem-date">
                  <ubi-icon class="ti-time" name="clock" size='15'/> {{daysRemaining(dateModification,30)}} {{$t('posts.list.daysRemaining')}}
                </div>
              </div>
              <div v-else>
                <el-row>
                  <el-col :span="24">
                    <div class="PostItem-location" v-if="donnees.ville">{{ donnees.ville.valeur | capitalize }}</div>
                    <div class="PostItem-location" v-else>&nbsp;</div>
                    <div class="PostItem-price">{{ prixDisplay }}</div>
                    <div class="PostItem-date">
                      <p class="date-creation-card">{{ $t("components.card.createdOn") }} <strong>{{ dateCreation.substring(0,16) }}</strong></p>
                      <p class="date-modification-card">{{ $t("components.card.updatedOn") }} <strong>{{ dateModification.substring(0,16) }}</strong></p>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </template>

            <img v-if="photoPrincipale != null" :src="photoPrincipale.url" height="350" alt="" />
            <div v-else style="text-align: center;">
              <ubi-icon class="no-photo" name="camera" size='350'/>
            </div>
            <div v-if="(photoPrincipale != null) && (etat === 'V') && !photoPrincipale.url.includes('sold_product')">
              <img :src="'Images/' + imageBv" height="95px" width="100%" alt="" style="opacity: 0.75; position: absolute; bottom: -18px;" />
            </div>

            <template v-slot:footer>
              <card-footer-immo
                  :id="id"
                  :etat="etat"
                  :published="published"
                  :typeObjet="typeObjet"
                  :typeOffre="typeOffre"
                  :reference="reference"
                  :sourceCode="sourceCode"
                  :nbContactsMailtracking="nbContactsMailtracking"
                  :annonceParente="annonceParente"
                  :donnees="donnees"
                  v-on:open-delete-modal="$emit('open-delete-modal',$event)"
                  v-on:open-use-model-modal="$emit('open-use-model-modal',$event)"
                  v-on:open-duplicate-modal="$emit('open-duplicate-modal',$event)"
                  v-on:archiver-bien-vendu-modale="$emit('archiver-bien-vendu-modale',$event)"
                  v-on:annonce-parente="$emit('annonce-parente', $event)"
                  v-on:diffuse-later="$emit('diffuse-later', $event)"
              ></card-footer-immo>
            </template>
          </ubi-card>
        </template>
      </ubi-card-container>
    </ubi-panel>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex'
import ElButton from '../../../../components/Button'
import { exportXlsPosts } from '../../../../services/posts'
import CardFooterImmo from './CardFooterImmo'
import moment from 'moment'
import { getFromSnake } from '@/helpers/functions/getFromSnake'
import { canSelectPostForBulk } from '@/helpers/posts/immoModelPermissions'
import UbiPanel from '@/components/Panel.vue'
import UbiListHeader from '@/components/lists/ListHeader.vue'
import UbiListSelection from '@/components/lists/ListSelection.vue'
import UbiListFooter from '@/components/lists/ListFooter.vue'
import UbiCardContainer from '@/components/CardContainer.vue'
import UbiCard from '@/components/Card.vue'
import UbiIcon from '@/components/Icon.vue'

export default {
  name: 'CardsListImmo',
  components: {
    UbiIcon,
    UbiCard,
    UbiCardContainer,
    UbiListFooter,
    UbiListSelection,
    UbiListHeader,
    UbiPanel,
    ElButton,
    CardFooterImmo
  },
  props: ['affichageReduit', 'limits', 'total', 'sortProperties', 'annonceFlux', 'unselect'],
  data () {
    return {
      referenceDuplication: null,
      selected: [],
      imageBv: 'filtre-bv.png',
      pendingMergePage: null,
      selectAllMode: false
    }
  },
  watch: {
    unselect: function (val) {
      this.selected = []
      this.selectAllMode = false
    },
    'filter.page' (newPage, oldPage) {
      if (this.selectAllMode && oldPage != null && newPage !== oldPage) {
        this.pendingMergePage = newPage
      }
    },
    'results.list' (list) {
      if (
        this.selectAllMode &&
          this.pendingMergePage != null &&
          this.filter.page === this.pendingMergePage &&
          list &&
          list.length
      ) {
        const idsToAdd = list
          .filter((row) => canSelectPostForBulk(this.isSubUser, this.getUser, row))
          .map(({ id }) => id)
        const merged = [...new Set([...(this.selected || []), ...idsToAdd])]
        this.selected = merged
        this.pendingMergePage = null
      }
    }
  },
  beforeMount () {
    if (this.sitimmoUser.bandeauBvCouleur) {
      this.imageBv = 'filtre-bv-' + this.sitimmoUser.bandeauBvCouleur + '.png'
    }
  },
  computed: {
    ...mapState('postsListImmo', ['filter', 'results', 'loading']),
    ...mapGetters(['hasMultiAccounts', 'isMainAccount', 'isSubAdmin', 'isSubUser', 'getOfferTypes', 'getPickerOptionsShortcuts', 'getUser']),
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    possedeContactManager () {
      return getFromSnake(this.sitimmoUser, 'possede_contact_manager')
    },
    isPromoteur () {
      return this.sitimmoUser.metier === 'PROMOTEUR'
    },
    isCmiste () {
      return this.sitimmoUser.metier === 'CMI'
    },
    saisit_en_ligne () {
      return (getFromSnake(this.sitimmoUser, 'saisit_annonces_en_ligne') || (getFromSnake(this.sitimmoUser, 'saisit_en_ligne_et_flux')))
    },
    packExpert () {
      return this.sitimmoUser.packDiffusion === 'pack_expert'
    },
    garantiePublication () {
      return this.sitimmoUser.garantiePublication === 'true'
    },
    nbStocks () {
      return this.sitimmoUser.stocks.length
    },
    stocks () {
      return this.sitimmoUser.stocks
    },
    saveFilters () {
      return this.$store.state.saveFilters
    },
    userFilter () {
      return this.filter.user
    },
    isBailleurSocial () {
      return this.sitimmoUser.metier === 'BAILLEUR_SOCIAL'
    },
    page: {
      get () {
        return this.filter.page
      },
      set (value) {
        this.setOffset((value - 1) * this.limit)
        this.setPage(value)
        this.filter.page = value
        this.$emit('load-data')
      }
    },
    limit: {
      get () {
        return this.filter.limit
      },
      set (value) {
        this.setLimit(value)
        this.setOffset(0)
        this.filter.page = 1
        this.$emit('load-data')
      }
    },
    sort: {
      get () {
        return this.filter.sort
      },
      async set (value) {
        this.setSort(value)
        this.setOffset(0)
        this.filter.page = 1
        this.$emit('load-data')
      }
    },
    currentSelectablePageIds () {
      return (this.results.list || [])
        .filter((row) => canSelectPostForBulk(this.isSubUser, this.getUser, row))
        .map(({ id }) => id)
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    reduire: function (value) {
      if (!value) return ''
      value = value.toString().substr(0, 47)
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    reduireRef: function (value) {
      if (!value) return ''
      value = value.toString().substr(0, 15)
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  methods: {
    ...mapMutations('postsListImmo', [
      'setPage',
      'setLimit',
      'setSort',
      'setSearch',
      'setFilter',
      'addFilter',
      'setOffset',
      'setLimit',
      'setResults',
      'resetFilter',
      'setObjectType'
    ]),
    ...mapMutations('dialogsPostsListImmo', [
      'SET_MODAL_DELETE',
      'SET_POST_TO_DELETE'
    ]),
    async doSelect (type) {
      if (type === '*') {
        this.selectAllMode = true
        const idsPage = (this.results.list || [])
          .filter((row) => canSelectPostForBulk(this.isSubUser, this.getUser, row))
          .map(({ id }) => id)
        const allIds = (this.selected || []).concat(idsPage)
        const merged = [...new Set(allIds)]
        this.selected = merged
      }
      if (type === null) {
        this.selected = []
        this.selectAllMode = false
      }
    },
    canSelectPostForBulkRow (etat, donnees) {
      return canSelectPostForBulk(this.isSubUser, this.getUser, { etat, donnees })
    },
    async exporter () {
      this.loading = true
      let i = 0
      let strSelectedIds = null
      this.selected.forEach(function (idSelected) {
        if (i === 0) {
          strSelectedIds = idSelected
        } else {
          strSelectedIds = strSelectedIds + ',' + idSelected
        }
        i++
      })

      const res = await exportXlsPosts(this.filter, strSelectedIds, false, this.$t('posts.list.filenameExportAds'))
      this.$message(res)
      this.loading = false
    },
    gestionAffichageReduit (rep) {
      this.$emit('affichage-reduit', rep)
    },
    daysRemaining (dateBegin, nbDays) {
      const dateEnd = moment(dateBegin, 'DD/MM/YYYY HH:mm:ss').add(nbDays, 'd').format('DD/MM/YYYY HH:mm:ss')
      const now = moment()
      const remaining = moment(now, 'DD/MM/YYYY HH:mm:ss').diff(moment(dateEnd, 'DD/MM/YYYY HH:mm:ss'))
      const formattedRemaining = Math.round(Math.abs(moment.duration(remaining).asDays()))
      return formattedRemaining
    },
    openDeleteModal (id) {
      this.SET_POST_TO_DELETE(id)
      this.SET_MODAL_DELETE(true)
    }
  }
}

</script>
<style lang="scss" scoped>
.date-creation-card {
  font-size: 12px;
  width: max-content;
  transform: translateX(15px);
  margin-top: -15px;
}
.date-modification-card {
  margin-top: -15px;
  font-size: 12px;
  margin-bottom: -15px;
}

/* Pour IPAD PRO */
@media screen and (min-width: 1024px) and (max-width: 1366px) {
  .PostsList {
    max-width: 88%;
  }
}
</style>
